export default "__VITE_ASSET__CRFmagpD__"